<template>
  <v-card class="elevation-0 mb-5">
    <v-card-title>
      <v-toolbar color="warning" class="elevation-0">
        <v-toolbar-title class="headline font-weight-bold">Student Information</v-toolbar-title>
      </v-toolbar>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field name="school" label="School" box value="Eagleridge Enrichment" disabled></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-select
            name="school_year"
            label="School Year"
            box
            :items="years"
            :rules="yearRules"
            v-model="year"
          ></v-select>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-select
            name="grade"
            label="Grade"
            box
            :rules="gradeRules"
            :items="grades"
            v-model="grade"
          ></v-select>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-select
            name="gender"
            label="Gender"
            box
            :rules="genderRules"
            :items="genders"
            v-model="gender"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="last_name"
            label="Legal Last Name"
            :rules="lastnameRules"
            box
            v-model="last_name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="first_name"
            label="Legal First Name"
            :rules="firstnameRules"
            box
            v-model="first_name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field name="middle_name" label="Legal Middle Name" box v-model="middle_name"></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap style="border-bottom: 1px solid black; margin: 25px 0;">
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field name="alt_last_name" label="Last Name Goes By" box v-model="alt_last_name"></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field name="nickname" label="Nickname" box v-model="nickname"></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <h3 class="title pa-2">Address</h3>
        </v-flex>
        <v-flex xs12 md6 lg5 px-2>
          <v-text-field
            name="address"
            label="Street Address"
            :rules="addressRules"
            box
            v-model="street_address"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field name="city" label="City" :rules="cityRules" box v-model="city"></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg2 px-2>
          <v-text-field name="state" label="State" :rules="stateRules" box v-model="state"></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg2 px-2>
          <v-text-field name="zipcode" label="Zip Code" :rules="zipcodeRules" box v-model="zipcode"></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <h3 class="title pa-2">Mailing Address (if different from above)</h3>
        </v-flex>
        <v-flex xs12 md6 lg5 px-2>
          <v-text-field
            name="mailing_address"
            label="Street Address"
            box
            v-model="mailing_street_address"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field name="mailing_city" label="City" box v-model="mailing_city"></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg2 px-2>
          <v-text-field name="mailing_state" label="State" box v-model="mailing_state"></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg2 px-2>
          <v-text-field name="mailing_zipcode" label="Zip Code" box v-model="mailing_zipcode"></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap style="border-bottom: 1px solid black; margin: 25px 0;">
        <v-flex xs12>
          <h3 class="title pa-2">Phone</h3>
        </v-flex>
        <v-flex xs12 md6 lg4 px-2>
          <v-text-field
            name="phone"
            label="Parent's phone"
            :rules="phoneRules"
            box
            mask="(###) ### - ####"
            v-model="phone"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg4 px-2>
          <v-radio-group :rules="validationRules" v-model="phone_type" row>
            <v-radio label="cell" value="cell"></v-radio>
            <v-radio label="home" value="home"></v-radio>
            <v-radio label="work" value="work"></v-radio>
            <v-radio label="other" value="other"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 md6 lg4 px-2>
          <v-checkbox
            v-model="phone_only_emergencies"
            label="Do not use except for attendance and/or emergencies"
          ></v-checkbox>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <h3 class="title pa-2">Birth Information</h3>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="birthdate"
            label="Birthdate (mm/dd/yyyy)"
            :rules="birthRules"
            box
            v-model="birthdate"
            mask="##/##/####"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="birthplace"
            label="Birthplace (city, state)"
            :rules="birthPlace"
            box
            v-model="birthplace"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg2 px-2>
          <v-select
            name="custody"
            label="Custody Issues"
            :rules="custodyRules"
            :items="booleans"
            box
            v-model="custody_issues"
          ></v-select>
        </v-flex>
        <v-flex xs12 md6 lg4 v-if="custody_issues">
          <div
            class="subheading px-3"
            :class="{ 'mb-5': $vuetify.breakpoint.smAndDown, 'py-3': $vuetify.breakpoint.xl }"
          >If there are custody issues, provide court documents to school office</div>
        </v-flex>
      </v-layout>
      <br>
      <br>
      <span>NOTE: THE FOLLOWING INFORMATION IS REQUIRED BY THE U.S. DEPARTMENT OF EDUCATION.</span>
      <v-layout row wrap>
        <v-flex xs12 md6 lg3 px-2>
          <v-layout column>
            <h3 class="title pa-2">Ethnicity</h3>
            <v-select
              name="latino"
              label="Hispanic/Latino"
              :rules="ethnicityRule"
              :items="booleans"
              box
              v-model="latino"
            ></v-select>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12 px-2>
          <h3 class="title">Race (check one or more, regardless of ethnicity)</h3>
          <v-layout
            :column="$vuetify.breakpoint.smAndDown ? true : false"
            :row="$vuetify.breakpoint.md ? true : false"
          >
            <v-checkbox
              v-model="selected_race"
              :rules="[() => rules.atLeastOneRace(selected_race)]"
              label="American Indian / Alaskan Native"
              value="American Indian / Alaskan Native"
              :hide-details="$vuetify.breakpoint.smAndDown"
            ></v-checkbox>
            <v-checkbox
              v-model="selected_race"
              :rules="[() => rules.atLeastOneRace(selected_race)]"
              label="Native Hawaiian / Other Pacific Islander"
              value="Native Hawaiian / Other Pacific Islander"
              :hide-details="true"
            ></v-checkbox>
            <v-checkbox
              v-model="selected_race"
              :rules="[() => rules.atLeastOneRace(selected_race)]"
              label="Black / African American"
              value="Black / African American"
              :hide-details="true"
            ></v-checkbox>
            <v-checkbox
              v-model="selected_race"
              :rules="[() => rules.atLeastOneRace(selected_race)]"
              label="Asian"
              value="Asian"
              :hide-details="true"
            ></v-checkbox>
            <v-checkbox
              v-model="selected_race"
              :rules="[() => rules.atLeastOneRace(selected_race)]"
              label="White"
              value="White"
              :hide-details="!$vuetify.breakpoint.smAndDown"
            ></v-checkbox>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <h3 class="title pa-2">Language</h3>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="home_language"
            label="Primary language in home"
            :rules="primaryLangRule"
            box
            v-model="home_language"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="student_language"
            label="Language spoken by student"
            :rules="langRule"
            box
            v-model="student_language"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="student_first_language"
            label="Student's first language"
            :rules="firstLangRule"
            box
            v-model="student_first_language"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 lg3 px-2>
          <v-text-field
            name="preferred_language"
            label="Language for all messages"
            :rules="langMessagesRule"
            box
            v-model="preferred_language"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      grades: [
        {
          text: "Kindergarten",
          value: "K"
        },
        {
          text: "1st Grade",
          value: "1"
        },
        {
          text: "2nd Grade",
          value: "2"
        },
        {
          text: "3rd Grade",
          value: "3"
        },
        {
          text: "4th Grade",
          value: "4"
        },
        {
          text: "5th Grade",
          value: "5"
        },
        {
          text: "6th Grade",
          value: "6"
        },
        {
          text: "7th Grade",
          value: "7"
        },
        {
          text: "8th Grade",
          value: "8"
        },
        {
          text: "9th Grade",
          value: "9"
        },
        {
          text: "10th Grade",
          value: "10"
        },
        {
          text: "11th Grade",
          value: "11"
        },
        {
          text: "12th Grade",
          value: "12"
        }
      ],
      genders: ["Male", "Female"],
      years: ["2021 - 2022", "2022 - 2023"],
      validationRules: [v => !!v || "Field is required"],
      yearRules: [v => !!v || "Year is required"],
      gradeRules: [v => !!v || "Grade is required"],
      genderRules: [v => !!v || "Gender is required"],
      lastnameRules: [v => !!v || "Last name is required"],
      firstnameRules: [v => !!v || "First name is required"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      addressRules: [v => !!v || "Address is required"],
      cityRules: [v => !!v || "City is required"],
      stateRules: [v => !!v || "State is required"],
      zipcodeRules: [v => !!v || "Zipcode is required"],
      phoneRules: [
        v => (!!v && v.length === 10) || "Valid phone number is required"
      ],
      birthRules: [v => !!v || "Birthdate is required"],
      birthPlace: [v => !!v || "Birthplace is required"],
      custodyRules: [v => v === true || v === false || "Custody is required"],
      ethnicityRule: [
        v => v === true || v === false || "Ethnicity is required"
      ],
      primaryLangRule: [v => !!v || "Primary language is required"],
      langRule: [v => !!v || "Primary language is required"],
      firstLangRule: [v => !!v || "First language is required"],
      langMessagesRule: [v => !!v || "Language for messages is required"],
      booleans: [
        {
          text: "Yes",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      rules: {
        atLeastOneRace: selected =>
          selected.length > 0 || "At least one item should be selected"
      }
    };
  },
  computed: {
    year: {
      get() {
        return this.$store.state.registration.student.year;
      },
      set(value) {
        this.$store.commit("registration/student/setYear", value);
      }
    },
    grade: {
      get() {
        return this.$store.state.registration.student.grade;
      },
      set(value) {
        this.$store.commit("registration/student/setGrade", value);
      }
    },
    gender: {
      get() {
        return this.$store.state.registration.student.gender;
      },
      set(value) {
        this.$store.commit("registration/student/setGender", value);
      }
    },
    first_name: {
      get() {
        return this.$store.state.registration.student.first_name;
      },
      set(value) {
        this.$store.commit("registration/student/setFirstName", value);
      }
    },
    last_name: {
      get() {
        return this.$store.state.registration.student.last_name;
      },
      set(value) {
        this.$store.commit("registration/student/setLastName", value);
      }
    },
    middle_name: {
      get() {
        return this.$store.state.registration.student.middle_name;
      },
      set(value) {
        this.$store.commit("registration/student/setMiddleName", value);
      }
    },
    alt_last_name: {
      get() {
        return this.$store.state.registration.student.alt_last_name;
      },
      set(value) {
        this.$store.commit("registration/student/setAltLastName", value);
      }
    },
    nickname: {
      get() {
        return this.$store.state.registration.student.nickname;
      },
      set(value) {
        this.$store.commit("registration/student/setNickname", value);
      }
    },
    street_address: {
      get() {
        return this.$store.state.registration.student.street_address;
      },
      set(value) {
        this.$store.commit("registration/student/setStreetAddress", value);
      }
    },
    city: {
      get() {
        return this.$store.state.registration.student.city;
      },
      set(value) {
        this.$store.commit("registration/student/setCity", value);
      }
    },
    state: {
      get() {
        return this.$store.state.registration.student.state;
      },
      set(value) {
        this.$store.commit("registration/student/setState", value);
      }
    },
    zipcode: {
      get() {
        return this.$store.state.registration.student.zipcode;
      },
      set(value) {
        this.$store.commit("registration/student/setZipcode", value);
      }
    },
    mailing_street_address: {
      get() {
        return this.$store.state.registration.student.mailing_street_address;
      },
      set(value) {
        this.$store.commit(
          "registration/student/setMailingStreetAddress",
          value
        );
      }
    },
    mailing_city: {
      get() {
        return this.$store.state.registration.student.mailing_city;
      },
      set(value) {
        this.$store.commit("registration/student/setMailingCity", value);
      }
    },
    mailing_state: {
      get() {
        return this.$store.state.registration.student.mailing_state;
      },
      set(value) {
        this.$store.commit("registration/student/setMailingState", value);
      }
    },
    mailing_zipcode: {
      get() {
        return this.$store.state.registration.student.mailing_zipcode;
      },
      set(value) {
        this.$store.commit("registration/student/setMailingZipcode", value);
      }
    },
    phone: {
      get() {
        return this.$store.state.registration.student.phone;
      },
      set(value) {
        this.$store.commit("registration/student/setPhone", value);
      }
    },
    phone_type: {
      get() {
        return this.$store.state.registration.student.phone_type;
      },
      set(value) {
        this.$store.commit("registration/student/setPhoneType", value);
      }
    },
    phone_only_emergencies: {
      get() {
        return this.$store.state.registration.student.phone_only_emergencies;
      },
      set(value) {
        this.$store.commit("registration/student/setPhoneUseCase", value);
      }
    },
    birthdate: {
      get() {
        return this.$store.state.registration.student.birthdate;
      },
      set(value) {
        this.$store.commit("registration/student/setBirthdate", value);
      }
    },
    birthplace: {
      get() {
        return this.$store.state.registration.student.birthplace;
      },
      set(value) {
        this.$store.commit("registration/student/setBirthplace", value);
      }
    },
    custody_issues: {
      get() {
        return this.$store.state.registration.student.custody_issues;
      },
      set(value) {
        this.$store.commit("registration/student/setCustodyIssues", value);
      }
    },
    latino: {
      get() {
        return this.$store.state.registration.student.latino;
      },
      set(value) {
        this.$store.commit("registration/student/setIsLatino", value);
      }
    },
    american_indian: {
      get() {
        return this.$store.state.registration.student.american_indian;
      },
      set(value) {
        this.$store.commit("registration/student/setIsAmericanIndian", value);
      }
    },
    pacific_islander: {
      get() {
        return this.$store.state.registration.student.pacific_islander;
      },
      set(value) {
        this.$store.commit("registration/student/setIsPacificIslander", value);
      }
    },
    black: {
      get() {
        return this.$store.state.registration.student.black;
      },
      set(value) {
        this.$store.commit("registration/student/setIsBlack", value);
      }
    },
    white: {
      get() {
        return this.$store.state.registration.student.white;
      },
      set(value) {
        this.$store.commit("registration/student/setIsWhite", value);
      }
    },
    asian: {
      get() {
        return this.$store.state.registration.student.asian;
      },
      set(value) {
        this.$store.commit("registration/student/setIsAsian", value);
      }
    },
    home_language: {
      get() {
        return this.$store.state.registration.student.home_language;
      },
      set(value) {
        this.$store.commit("registration/student/setHomeLanguage", value);
      }
    },
    student_language: {
      get() {
        return this.$store.state.registration.student.student_language;
      },
      set(value) {
        this.$store.commit("registration/student/setStudentLanguage", value);
      }
    },
    student_first_language: {
      get() {
        return this.$store.state.registration.student.student_first_language;
      },
      set(value) {
        this.$store.commit(
          "registration/student/setStudentFirstLanguage",
          value
        );
      }
    },
    preferred_language: {
      get() {
        return this.$store.state.registration.student.preferred_language;
      },
      set(value) {
        this.$store.commit("registration/student/setPreferredLanguage", value);
      }
    },
    selected_race: {
      get() {
        return this.$store.state.registration.student.selected_race;
      },
      set(value) {
        this.$store.commit("registration/student/setSelectedRace", value);
      }
    }
  }
};
</script>

<style scoped>
.notifications > * {
  width: 100%;
  text-align: center;
  margin: 0;
}
</style>
